import LocalStorage from 'Utils/localStorage';

const CACHE_KEY = 'bilyoner_app_store_data';
const CACHE_TTL_MS = 7 * 24 * 60 * 60 * 1000;
const APP_STORE_URL = 'https://itunes.apple.com/lookup?id=323678768&country=tr';

let _inFlight = null;

export async function fetchAppStoreData () {
  const cached = LocalStorage.get(CACHE_KEY);
  if (cached && Date.now() - cached.fetchedAt < CACHE_TTL_MS) {
    return cached.data;
  }

  if (_inFlight) return _inFlight;

  _inFlight = (async () => {
    try {
      const response = await fetch(APP_STORE_URL);
      if (!response.ok) throw new Error('App Store API error');
      const json = await response.json();
      if (!json.resultCount) return null;

      const appInfo = json?.results[0];
      const data = {
        rating: appInfo?.averageUserRating,
        ratingCount: appInfo?.userRatingCount,
        version: appInfo?.version,
      };

      LocalStorage.set(CACHE_KEY, { data, fetchedAt: Date.now() });
      return data;
    } catch {
      return null;
    } finally {
      _inFlight = null;
    }
  })();

  return _inFlight;
}

export function formatRatingCount (count) {
  if (count >= 1_000_000) {
    const mn = count / 1_000_000;
    const formatted = Number.isInteger(mn) ? mn : parseFloat(mn.toFixed(1));
    return `${formatted}Mn`;
  }
  if (count >= 1_000) {
    return `${Math.floor(count / 1_000)}K+`;
  }
  return String(count);
}
